import centers from "../../assets/images/home/centers.svg";
import world from "../../assets/images/home/world.svg";

const PresenceStats = () => {
  return (
    <section className="bg-white/10 backdrop-blur-md border border-white/20 p-2 -mt-20  shadow-[0_-4px_20px_rgba(0,0,0,0.2)]">
      <div className="mx-auto flex flex-col md:flex-row justify-center items-center md:gap-8 gap-4 container">
        {/* Card 1 */}
        <div className="flex items-center justify-center gap-4 rounded-xl  p-6 md:w-[40%]">
          <div className="bg-white p-4 rounded-lg shadow-xl">
            <img src={centers} alt="" className="w-3/5 m-auto" />
          </div>
          <p className="text-xl font-outfitLight tracking-widest md:w-[10%] mb-10">
            WE HAVE
          </p>
          <div>
            <p className="text-5xl font-bold text-black">1000+ </p>
            <p className="text-base font-outfitMedium tracking-[0.5em]">
              CENTRES
            </p>
            <p className="text-base font-outfitLight tracking-widest">
              ACROSS INDIA
            </p>
          </div>
        </div>

        {/* Card 2 */}
        <div className="flex items-center justify-center gap-4 rounded-xl  p-6 md:w-[40%]">
          <div className="bg-white p-4 rounded-lg shadow-xl">
            <img src={world} className="w-3/5 m-auto" alt="" />
          </div>
          <div className="uppercase">
            <p className="text-xl font-outfitLight tracking-widest">
              Present in{" "}
            </p>
            <div className="flex gap-2">
              <p className="text-5xl font-bold text-black">300+ </p>
              <div>

              <p className="text-base font-outfitMedium tracking-[0.5em]">
                cities
              </p>
              <p className="text-base font-outfitLight tracking-widest">
                across India
              </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PresenceStats;
